import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import RightViewLayout from "../../components/RighViewLayout";
import CustomInput from "../../components/CustomInput";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getMenus, getRoleById } from "../../services/UserManagementService";
import { REACT_AUTHORIZATION_LEVEL } from "../../router/ReactEndPoints";

export default function ViewAuthorizationLevel() {
  const { state } = useLocation();

  const { t } = useTranslation();
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [menus, setMenus] = useState([]);

  const [payload, setPayload] = useState({
    id: "",
    name: "",
    code: "",
    permissionIds: [],
  });

  const [error, setError] = useState({
    name: "",
    code: "",
    permissionIds: "",
  });

  useEffect(() => {
    getRoleById(state?.id).then((res) => {
      if (res?.data?.code == "LVLI0000") {
        const list = res?.data?.data?.permissionIdList;
        setSelectedPermissions(list);
        setPayload({
          ...payload,
          ...res?.data?.data,
        });
      }
    });
  }, []);

  const loadData = () => {
    getMenus().then((res) => {
      if (res?.data?.code == "LVLI0000") {
        setMenus(res?.data?.data);
      }
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      ...error,
      [name]: "",
      common: "",
    });
  };

  useEffect(() => {
    setPayload({
      ...payload,
      permissionIds: selectedPermissions,
    });
  }, [selectedPermissions]);

  return (
    <RightViewLayout
      title={t("authorization.view")}
      navigateBack={REACT_AUTHORIZATION_LEVEL}>
      <Box pr={2}>
        <Grid>
          <Card
            elevation={0}
            sx={{
              background: " #FFFFFF 0% 0% no-repeat padding-box",
              fontWeight: "bold",
              opacity: 1,
              borderRadius: "8px",
            }}>
            <CardContent style={{ width: "30%" }}>
              <CustomInput
                resetError={() => setError({ ...error, name: "" })}
                required
                error={error.name}
                label={t("authorization.name")}
                size="small"
                name="name"
                value={payload.name}
                helperText={error.name}
                validation="alpha-numeric"
                handleChange={handleChange}
                disabled={true}
                inputProps={{
                  maxLength: 50,
                }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Typography
          pt={1}
          pl={0}
          sx={{
            textAlign: "left",
            font: "normal normal medium 16px/22px Roboto",
            fontWeight: "bold",
            letterSpacing: "0px",
            opacity: "0.8",
          }}>
          {t("authorization.list")}
        </Typography>
        {menus?.map((menu) => {
          return (
            <Grid key={menu.id} pt={1.5}>
              <Card
                elevation={0}
                sx={{
                  background: "#FFFFFF 0% 0% no-repeat padding-box",
                  fontWeight: "bold",
                  borderRadius: "8px",
                }}>
                <FormGroup
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    ml: 4, // 设置左边距
                  }}>
                  <Grid lg={2}>
                    <FormControlLabel
                      key={menu.id}
                      disabled={true}
                      control={
                        <Checkbox
                          id={`permission-checkbox-${menu.id}`}
                          checked={selectedPermissions?.includes(menu.id)}
                        />
                      }
                      label={menu.name}
                      sx={{
                        textAlign: "left",
                        font: "normal normal medium 28px/38px Roboto",
                        fontWeight: "bold",
                        letterSpacing: "0px",
                        color: "#474B4F",
                      }}
                    />
                  </Grid>
                </FormGroup>

                <CardContent>
                  {menu?.menuItemList?.map((item) => (
                    <Grid
                      key={item.id}
                      sx={{
                        textAlign: "left",
                        font: "normal normal medium 32px/38px Roboto",
                        letterSpacing: "0px",
                        color: "#474B4F",
                      }}>
                      <FormGroup
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          ml: 6, // 设置左边距
                        }}>
                        <Grid lg={2}>
                          {item.name !== null ? (
                            <FormControlLabel
                              key={item.id}
                              disabled={true}
                              control={
                                <Checkbox
                                  id={`permission-checkbox-${item.id}`}
                                  checked={selectedPermissions?.includes(
                                    item.id
                                  )}
                                />
                              }
                              label={item.name}
                              sx={{
                                textAlign: "left",
                                font: "normal normal medium 18px/24px Roboto",
                                fontWeight: "bold",
                                letterSpacing: "0px",

                                color: "#474B4F",
                              }}
                            />
                          ) : null}
                        </Grid>
                      </FormGroup>

                      <FormGroup
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          ml: 12,
                        }}>
                        {item?.permissionList.map((permission) => (
                          <Grid lg={2}>
                            <FormControlLabel
                              key={permission.id}
                              disabled={true}
                              control={
                                <Checkbox
                                  id={`permission-checkbox-${permission.id}`}
                                  checked={selectedPermissions?.includes(
                                    permission.id
                                  )}
                                />
                              }
                              label={permission.name}
                              sx={{
                                width: 200,
                                mt: 1,
                              }}
                            />
                          </Grid>
                        ))}
                      </FormGroup>
                    </Grid>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Box>
    </RightViewLayout>
  );
}
